import { TFunction } from 'i18next'

interface Translation {
  alert: string
  body: string
  cta: string
  frenchLegalListPoint1: string
  frenchLegalListPoint2: string
  frenchLegalListPoint3: string
  frenchLegalListTitle: string
  subtitle: string
  title: string
}

export const getTranslations = (isVATEnabled: boolean, t: TFunction): Translation => {
  if (isVATEnabled) {
    return {
      alert: t('settings.organization.organization_info.vat_confirmation_modal.disable.alert'),
      body: t('settings.organization.organization_info.vat_confirmation_modal.disable.text'),
      cta: t('settings.organization.organization_info.vat_confirmation_modal.disable.cta'),
      frenchLegalListPoint1: t(
        'settings.organization.organization_info.vat_confirmation_modal.disable.fr_legal_list.point_1',
      ),
      frenchLegalListPoint2: t(
        'settings.organization.organization_info.vat_confirmation_modal.disable.fr_legal_list.point_2',
      ),
      frenchLegalListPoint3: t(
        'settings.organization.organization_info.vat_confirmation_modal.disable.fr_legal_list.point_3',
      ),
      frenchLegalListTitle: t(
        'settings.organization.organization_info.vat_confirmation_modal.disable.fr_legal_list.title',
      ),
      subtitle: t('settings.organization.organization_info.vat_confirmation_modal.disable.subtitle'),
      title: t('settings.organization.organization_info.vat_confirmation_modal.disable.title'),
    }
  }

  return {
    alert: t('settings.organization.organization_info.vat_confirmation_modal.enable.alert'),
    body: t('settings.organization.organization_info.vat_confirmation_modal.enable.text'),
    cta: t('settings.organization.organization_info.vat_confirmation_modal.enable.cta'),
    frenchLegalListPoint1: t(
      'settings.organization.organization_info.vat_confirmation_modal.enable.fr_legal_list.point_1',
    ),
    frenchLegalListPoint2: t(
      'settings.organization.organization_info.vat_confirmation_modal.enable.fr_legal_list.point_2',
    ),
    frenchLegalListPoint3: t(
      'settings.organization.organization_info.vat_confirmation_modal.enable.fr_legal_list.point_3',
    ),
    frenchLegalListTitle: t(
      'settings.organization.organization_info.vat_confirmation_modal.enable.fr_legal_list.title',
    ),
    subtitle: t('settings.organization.organization_info.vat_confirmation_modal.enable.subtitle'),
    title: t('settings.organization.organization_info.vat_confirmation_modal.enable.title'),
  }
}
